import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  toggle() {
    if (this.checkboxTarget.checked) {
      this._tagToggles().forEach(controller => {
        if (!controller.activeValue) controller.toggle()
      })
    } else {
      this._tagToggles().forEach(controller => {
        if (controller.activeValue) controller.toggle()
      })
    }
  }

  // Keep checkbox in sync when individual tags are toggled
  sync() {
    const toggles = this._tagToggles()
    const allActive = toggles.length > 0 && toggles.every(c => c.activeValue)
    this.checkboxTarget.checked = allActive
    this.checkboxTarget.indeterminate = !allActive && toggles.some(c => c.activeValue)
  }

  _tagToggles() {
    const elements = this.element.querySelectorAll('[data-controller*="tag-toggle"]')
    return Array.from(elements).map(el =>
      this.application.getControllerForElementAndIdentifier(el, 'tag-toggle')
    ).filter(Boolean)
  }
}
